import { SerializedData, Store } from "bernie-core";
import { Logger } from "bernie-logger";
import { PropertyFiltersContext } from "./context/PropertyFiltersContext";
import { PropertyFiltersQuery } from "__generated__/api";
import _SortAndFilter = PropertyFiltersQuery._SortAndFilter;
import { PROPERTY_FILTERS_COMPONENT_MAP } from "components/shared/PropertyFIlterComponents/map/PropertyFiltersComponentMap";

const validFilterNames = Object.keys(PROPERTY_FILTERS_COMPONENT_MAP);

export class PropertyFiltersStore extends Store {
  public filtersContext: PropertyFiltersContext;

  public constructor(state: SerializedData, logger: Logger) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    // Does nothing
  }

  public getFiltersContext(response: _SortAndFilter[], regionId: string) {
    if (!this.filtersContext) {
      const validFilters = response.filter((filter) => validFilterNames.includes(filter?.name));

      this.filtersContext = new PropertyFiltersContext(validFilters, regionId);
    }

    return this.filtersContext;
  }
}
